const API_URL = process.env.REACT_APP_API_URL;
const USER_SIGNUP = '/user/signup';
const USER_SIGNIN = '/user/signin';
const USER_INFO = '/user';
const USER_SETPASSWORD = '/userPassword';
const DISTRIBUTOR_TEMPLATE = '/user/distributor-template';
const GOLD_PARTNER_ROLE = 'gold_partner';
const CREDENTIAL_TEMPLATE_ROLES = Object.freeze(['distributor', GOLD_PARTNER_ROLE, 'admin', 'superadmin']);
const USER_CREATED = '\u00A1Usuario creado con \u00E9xito! Bienvenido a nuestra comunidad. A continuación puedes ingresar con tu cuenta.';
const USER_LOGGED = '\u00A1Bienvenid@ a Gold Service!';
const USER_SESSION_EXPIRED = 'Sesión caducada, por favor inicia sesión otra vez.';
const USER_UPDATE_CART = '/setCart';
const DELETE_CART_ITEM = '/deleteCartItem';
const USER_PURCHASE = '/purchaseItems';
const CART_RESERVATION = '/cartReservation';
const USER_MOVEMENTS = '/myMovements';
const USER_NOTIFICATIONS = '/notifications';
const PUSH_NOTIFICATIONS = '/notifications/push';
const GET_CATEGORIES = '/categories';
const GET_PRODUCTS_BY_CATEGORY = '/productsByCategory';
const GET_PRODUCT_BY_ID = '/product';
const GET_ALL_PRODUCTS = '/products';
const GET_CART_PRODUCTS = '/cartProducts';
const QUERY_PRODUCTS = '/queryProducts';
const MODAL_TITLE_SUCCCESS = '\u00A1Se ha realizado con \u00E9xito!';
const MODAL_TITLE_ERROR = '\u00A1Oops, error en la solicitud!';
const MODAL_TITLE_SIGNOUT = 'Desconexión exitosa.';
const MODAL_BODY_SIGNOUT = 'Hasta luego, vuelve pronto...';
const MODAL_ITEM_ADDED = 'Se ha agregado el item al carrito.';
const PARAMS_CATEGORY_ID = 'category_id=';
const PARAMS_PAGE = 'page=';
const PARAMS_PRODUCT = 'product=';
const PARAMS_QUERY_PRODUCT = 'productQuery=';
const PRODUCT_STATUS_ACTIVE = 'active';
const PRODUCT_STATUS_INACTIVE = 'inactive';
const PURCHASE_SUCCESS_CODE = 'PURCHASE_SUCCESS';
const INSUFFICIENT_BALANCE_CODE = 'INSUFFICIENT_BALANCE';
const INSUFFICIENT_STOCK_CODE = 'INSUFFICIENT_STOCK';
const EMPTY_CART_CODE = 'EMPTY_CART';
const PRODUCT_NOT_AVAILABLE_CODE = 'PRODUCT_NOT_AVAILABLE';
const INVALID_SESSION_CODE = 'INVALID_SESSION';
const INTERNAL_ERROR_CODE = 'INTERNAL_ERROR';
const COMBO_NOT_AVAILABLE_CODE = 'COMBO_NOT_AVAILABLE';
const IDEMPOTENCY_CONFLICT_CODE = 'IDEMPOTENCY_CONFLICT';
const PURCHASE_CONFLICT_CODE = 'PURCHASE_CONFLICT';
const INVALID_PURCHASE_REQUEST_CODE = 'INVALID_PURCHASE_REQUEST';
const INVALID_IDEMPOTENCY_KEY_CODE = 'INVALID_IDEMPOTENCY_KEY';
const USER_NOT_FOUND_CODE = 'USER_NOT_FOUND';
const TRANSACTIONS_UNAVAILABLE_CODE = 'TRANSACTIONS_UNAVAILABLE';
const PURCHASE_ERROR_MESSAGES = Object.freeze({
    [INSUFFICIENT_BALANCE_CODE]: 'Saldo insuficiente',
    [INSUFFICIENT_STOCK_CODE]: 'Stock insuficiente',
    [EMPTY_CART_CODE]: 'Tu carrito está vacío',
    [PRODUCT_NOT_AVAILABLE_CODE]: 'Producto no disponible',
    [INVALID_SESSION_CODE]: 'Tu sesión expiró',
    [INTERNAL_ERROR_CODE]: 'Ocurrió un error inesperado',
    [COMBO_NOT_AVAILABLE_CODE]: 'Este combo ya no está disponible',
    [IDEMPOTENCY_CONFLICT_CODE]: 'Ya se está procesando esta compra',
    [PURCHASE_CONFLICT_CODE]: 'No pudimos completar la compra, intenta nuevamente',
    [INVALID_PURCHASE_REQUEST_CODE]: 'Solicitud de compra inválida',
    [INVALID_IDEMPOTENCY_KEY_CODE]: 'No pudimos procesar la compra, intenta nuevamente',
    [USER_NOT_FOUND_CODE]: 'No pudimos identificar tu usuario',
    [TRANSACTIONS_UNAVAILABLE_CODE]: 'Servicio no disponible temporalmente, intenta más tarde'
});
const LANGUAGE_TAG = 'es-CO';
const CURRENCY_NAME = 'COP';
const COUNTRY_PREFIX = '57'
const WHATSAPP_NUMBER = `${COUNTRY_PREFIX}3184831432`;
const MAX_VISIBLE_PAGES = 5;
const PAYMENT_STATE = {
    Completed: 'Completado',
    Pending: 'Pendiente',
    Cancelled: 'Cancelado'
};
const WIDTH_MOBILE = 500;
const FACEBOOK_PAGE = 'https://www.facebook.com/profile.php?id=61553049745191&mibextid=kFxxJD';
const INSTAGRAM_PAGE = 'https://instagram.com';
// Versioned so legacy persisted Product carts are never treated as the
// authenticated user's current cart after this client is deployed.
const KEY_STORAGE_BASE = 'GLDST1';

// Combos (Sprint Combos 1.0C-B) — public read-only prebuilt-cart catalog.
const STORE_COMBOS = '/store/combos';
const STORE_COMBO = '/store/combo';
const STORE_TOP_SELLING = '/store/top-selling';
const COMBO_DEFAULT_PAGE_SIZE = 10;
const COMBO_AVAILABILITY_STATE = Object.freeze({
    AVAILABLE: 'AVAILABLE',
    RESERVABLE: 'RESERVABLE',
    SOLD_OUT: 'SOLD_OUT',
    UNAVAILABLE: 'UNAVAILABLE'
});
const COMBO_AVAILABILITY_LABELS = Object.freeze({
    AVAILABLE: 'Disponible',
    RESERVABLE: 'Entrega estimada',
    SOLD_OUT: 'Agotado',
    UNAVAILABLE: 'No disponible'
});
const COMBO_SECTION_EMPTY_MESSAGE = 'Próximamente encontrarás paquetes especiales de Servicios.';
const COMBO_SECTION_ERROR_MESSAGE = 'No pudimos cargar los combos en este momento.';
const COMBO_ADDED_MESSAGE = 'Combo añadido a tu carrito.';
const COMBO_ALREADY_IN_CART_MESSAGE = 'Este combo ya está en tu carrito.';
const COMBO_NO_LONGER_AVAILABLE_MESSAGE = 'Este combo ya no está disponible.';
const COMBO_ADD_ERROR_MESSAGE = 'No pudimos añadir el combo. Intenta nuevamente.';
const COMBO_TOGETHER_DELIVERY_MESSAGE = 'Los Servicios se entregarán juntos.';

// Recargas automáticas BRE-B (docs/BREB_INTEGRATION.md en gold_server-develop).
const RECHARGE_REQUESTS_URL = '/wallet/recharge-requests';
const RECHARGE_PAYERS_URL = '/wallet/payers';
const RECHARGE_POLL_INTERVAL_MS = 3000;
const RECHARGE_COUNTDOWN_INTERVAL_MS = 1000;
const RECHARGE_MIN_AMOUNT = 1;
const RECHARGE_MAX_AMOUNT = 50000000;
const RECHARGE_STATUS = Object.freeze({
    PENDING: 'pending',
    COMPLETED: 'completed',
    EXPIRED: 'expired',
    CANCELLED: 'cancelled',
    MANUAL_REVIEW: 'manual_review'
});
const RECHARGE_STATUS_LABELS = Object.freeze({
    [RECHARGE_STATUS.PENDING]: 'Pendiente',
    [RECHARGE_STATUS.COMPLETED]: 'Completada',
    [RECHARGE_STATUS.EXPIRED]: 'Vencida',
    [RECHARGE_STATUS.CANCELLED]: 'Cancelada',
    [RECHARGE_STATUS.MANUAL_REVIEW]: 'En revisión manual'
});
const ACTIVE_RECHARGE_REQUEST_CODE = 'ACTIVE_RECHARGE_REQUEST';
const INVALID_RECHARGE_AMOUNT_CODE = 'INVALID_RECHARGE_AMOUNT';
const INVALID_PAYER_NAME_CODE = 'INVALID_PAYER_NAME';
const INVALID_RECHARGE_REQUEST_ID_CODE = 'INVALID_RECHARGE_REQUEST_ID';
const RECHARGE_REQUEST_NOT_FOUND_CODE = 'RECHARGE_REQUEST_NOT_FOUND';
const RECHARGE_NOT_CANCELLABLE_CODE = 'RECHARGE_NOT_CANCELLABLE';
const RECHARGE_ERROR_MESSAGES = Object.freeze({
    [ACTIVE_RECHARGE_REQUEST_CODE]: 'Ya tienes una recarga pendiente.',
    [INVALID_RECHARGE_AMOUNT_CODE]: 'El monto debe estar entre 1 y 50.000.000 COP.',
    [INVALID_PAYER_NAME_CODE]: 'Ingresa al menos dos nombres o apellidos del titular que realizará el pago.',
    [INVALID_RECHARGE_REQUEST_ID_CODE]: 'La solicitud de recarga no es válida.',
    [RECHARGE_REQUEST_NOT_FOUND_CODE]: 'No encontramos esa solicitud de recarga.',
    [RECHARGE_NOT_CANCELLABLE_CODE]: 'Esta solicitud ya no se puede cancelar.',
    [USER_NOT_FOUND_CODE]: 'No pudimos identificar tu usuario.'
});

export const constants = Object.freeze({
    API_URL,
    USER_SIGNUP,
    USER_SIGNIN,
    USER_INFO,
    USER_SETPASSWORD,
    DISTRIBUTOR_TEMPLATE,
    GOLD_PARTNER_ROLE,
    CREDENTIAL_TEMPLATE_ROLES,
    USER_CREATED,
    USER_LOGGED,
    USER_SESSION_EXPIRED,
    GET_CATEGORIES,
    GET_PRODUCTS_BY_CATEGORY,
    GET_PRODUCT_BY_ID,
    GET_ALL_PRODUCTS,
    GET_CART_PRODUCTS,
    QUERY_PRODUCTS,
    MODAL_TITLE_SUCCCESS,
    MODAL_TITLE_ERROR,
    MODAL_TITLE_SIGNOUT,
    MODAL_BODY_SIGNOUT,
    MODAL_ITEM_ADDED,
    PARAMS_CATEGORY_ID,
    PARAMS_PAGE,
    PARAMS_PRODUCT,
    PARAMS_QUERY_PRODUCT,
    PRODUCT_STATUS_ACTIVE,
    PRODUCT_STATUS_INACTIVE,
    PURCHASE_SUCCESS_CODE,
    INSUFFICIENT_BALANCE_CODE,
    INSUFFICIENT_STOCK_CODE,
    EMPTY_CART_CODE,
    PRODUCT_NOT_AVAILABLE_CODE,
    INVALID_SESSION_CODE,
    INTERNAL_ERROR_CODE,
    COMBO_NOT_AVAILABLE_CODE,
    IDEMPOTENCY_CONFLICT_CODE,
    PURCHASE_CONFLICT_CODE,
    INVALID_PURCHASE_REQUEST_CODE,
    INVALID_IDEMPOTENCY_KEY_CODE,
    USER_NOT_FOUND_CODE,
    TRANSACTIONS_UNAVAILABLE_CODE,
    PURCHASE_ERROR_MESSAGES,
    LANGUAGE_TAG,
    CURRENCY_NAME,
    WHATSAPP_NUMBER,
    MAX_VISIBLE_PAGES,
    PAYMENT_STATE,
    USER_UPDATE_CART,
    DELETE_CART_ITEM,
    USER_PURCHASE,
    CART_RESERVATION,
    USER_MOVEMENTS,
    USER_NOTIFICATIONS,
    PUSH_NOTIFICATIONS,
    WIDTH_MOBILE,
    FACEBOOK_PAGE,
    INSTAGRAM_PAGE,
    KEY_STORAGE_BASE,
    STORE_COMBOS,
    STORE_COMBO,
    STORE_TOP_SELLING,
    COMBO_DEFAULT_PAGE_SIZE,
    COMBO_AVAILABILITY_STATE,
    COMBO_AVAILABILITY_LABELS,
    COMBO_SECTION_EMPTY_MESSAGE,
    COMBO_SECTION_ERROR_MESSAGE,
    COMBO_ADDED_MESSAGE,
    COMBO_ALREADY_IN_CART_MESSAGE,
    COMBO_NO_LONGER_AVAILABLE_MESSAGE,
    COMBO_ADD_ERROR_MESSAGE,
    COMBO_TOGETHER_DELIVERY_MESSAGE,
    RECHARGE_REQUESTS_URL,
    RECHARGE_PAYERS_URL,
    RECHARGE_POLL_INTERVAL_MS,
    RECHARGE_COUNTDOWN_INTERVAL_MS,
    RECHARGE_MIN_AMOUNT,
    RECHARGE_MAX_AMOUNT,
    RECHARGE_STATUS,
    RECHARGE_STATUS_LABELS,
    ACTIVE_RECHARGE_REQUEST_CODE,
    INVALID_RECHARGE_AMOUNT_CODE,
    INVALID_PAYER_NAME_CODE,
    INVALID_RECHARGE_REQUEST_ID_CODE,
    RECHARGE_REQUEST_NOT_FOUND_CODE,
    RECHARGE_NOT_CANCELLABLE_CODE,
    RECHARGE_ERROR_MESSAGES
});
